import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as UserSelectors from './user.selectors';
import { TopBarActions } from './user.actions';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  private readonly store: Store = inject(Store);

  public readonly planPermissionsLoaded: Signal<boolean> =
    this.store.selectSignal(UserSelectors.selectPlanPermissionsLoaded);
  public readonly userShowLoader: Signal<boolean> = this.store.selectSignal(
    UserSelectors.selectUserShowLoader,
  );
  public readonly personId: Signal<string | undefined> =
    this.store.selectSignal(UserSelectors.selectPersonId);
  public readonly personIdLoaded: Signal<boolean> = this.store.selectSignal(
    UserSelectors.selectPersonIdLoaded,
  );
  public readonly hasPersonIdError: Signal<boolean> = this.store.selectSignal(
    UserSelectors.selectHasPersonIdError,
  );

  public topBarFeedbackClicked(): void {
    this.store.dispatch(TopBarActions.feedbackClicked());
  }

  public moreMenuFeedbackClicked(): void {
    this.store.dispatch(TopBarActions.feedbackClicked());
  }
}
